<template>
    <div class="modal fade" id="createNotificationSubscriptonModal" role="dialog" aria-labelledby="createNotificationSubscriptonModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="createNotificationSubscriptonModalLabel">{{$t('upcomingEvents.notificationSubsciption')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <SubscriptionEditCard v-model="model"
                                      v-if="showEditor"
                                      :create="true"
                                      :eventName="eventName"
                                      @save="onSave"
                                      @cancel="onCancel">
                    </SubscriptionEditCard>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { NotificationSubscription } from '@/models/models';
    import SubscriptionEditCard from './SubscriptionEditCard';

    export default {
        inject: ['$validator'],
        components: {
            SubscriptionEditCard
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            eventName: String,
            eventId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                showEditor: false,
                model: new NotificationSubscription(),
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.model = new NotificationSubscription();
                this.$validator.reset();
                this.showEditor = false;
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onSave(model) {
                this.$emit('onCreate', model);
                this.onClose();
            },
            onCancel() {
                this.onClose();
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new NotificationSubscription({ eventId: this.eventId, email: this.$store.getters.userEmail });
                    this.showEditor = true;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
